import React from 'react';

import classNames from 'classnames';
import moment from 'moment';
import { Month as MonthDaysProps, InRangeResult, ViewCommonProps } from '../../../../../../components/shared/calendar/types';

import styles from './base-calendar.module.scss';
import MonthView from './month-view';
import { NavigationLabel } from './navigation';

interface MonthRendererProps extends ViewCommonProps {
    month?: MonthDaysProps;
    previewEnd?: moment.Moment;
    getIsDayInRange?: (date: moment.Moment) => InRangeResult | undefined,
    fullFlex?: boolean,
    small?: boolean,
    showHeader?: boolean
}

export default function Month (props: MonthRendererProps) {
    const { activeDate, small, showHeader } = props;

    const handleGetIsDayInRange = (day: moment.Moment): InRangeResult | undefined => {
        return props.getIsDayInRange?.(day);
    }

    return (<div className={classNames({
        [styles.month]: true,
        [styles.flex]: props.fullFlex
    })}>
        {
            showHeader && <div className={styles.monthHeader}>
                <NavigationLabel date={activeDate} view={'month'} />
            </div>
        }
        <MonthView onDayClick={props.onDayClick}
            onDayOverEnter={props.onDayOverEnter}
            onDayOverLeave={props.onDayOverLeave}
            month={props.month}
            activeDate={activeDate}
            getDayIsInRange={(day) => props.getIsDayInRange ? handleGetIsDayInRange(day) : undefined}
            range={props.previewEnd} 
            small={small}
            minDate={props.minDate?.startOf('day')}
            maxDate={props.maxDate?.startOf('day')}
            dense={props.dense}/>
    </div>)
}
